// extracted by mini-css-extract-plugin
export default {"form":"ViewContrato_form__fVnEb","areaBtn":"ViewContrato_areaBtn__HG6n7","btn":"ViewContrato_btn__+eWAI","btn2":"ViewContrato_btn2__iXE16"};